import request from '../utils/request'

export function auditAppListPageApi (data) {
  return request({
    url: 'api/audit/appListPage',
    method: 'post',
    data
  })
}

export function auditInfoApi (id) {
  return request({
    url: `api/audit/info/${id}`,
    method: 'get'
  })
}

export function auditCheckGiveUpCustomerAuditApi (data) {
  return request({
    url: 'api/audit/checkGiveUpCustomerAudit',
    method: 'post',
    data
  })
}
